import React from "react";
import ReactDOM from "react-dom";

import "antd/dist/antd.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "../src/assets/stylesheets/main.scss";
import "../src/assets/stylesheets/mobile.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "animate.css/animate.min.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
